module.exports = __webpack_public_path__ + "assets/img/shuoshuo_book.a6054abe.svg";